import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_add_new_company_board_item = _resolveComponent("add-new-company-board-item")!

  return (_ctx.item)
    ? (_openBlock(), _createBlock(_component_add_new_company_board_item, {
        key: 0,
        item: _ctx.item,
        tags: _ctx.tags,
        heading: "Add Task",
        onClose: _ctx.onClose
      }, null, 8, ["item", "tags", "onClose"]))
    : _createCommentVNode("", true)
}